import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'
import PAGE_FEATURES from '@/constants/page-features'
import checkPageFeaturesGuard from '@/router/guards/check-page-features-guard'
import checkAddPageGuard from '@/router/guards/check-add-page-guard'

export default [
  {
    path: '/fb',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard, checkAddPageGuard, checkPageFeaturesGuard]),
    children: [
      {
        path: 'posts',
        name: 'owner:posts',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "reply" */ '@/views/owner-fb/page/posts.vue'),
      },
      {
        path: 'reports',
        name: 'owner:reports',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "reply" */ '@/views/owner-fb/reply/ReportsTable.vue'),
      },
      {
        path: 'reply/:id',
        name: 'owner:reply',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "reply" */ '@/views/owner-fb/reply/AddReply.vue'),
      },
      {
        path: 'reply/:id/edit',
        name: 'owner:reply-edit',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "reply" */ '@/views/owner-fb/reply/EditReply.vue'),
      },
      {
        path: 'replies/templates',
        name: 'owner:reply-templates',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "reply-template" */ '@/views/owner-fb/reply/ReplyTemplatesTable.vue'),
      },
      {
        path: 'replies/add-template',
        name: 'owner:reply-template',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "reply-template" */ '@/views/owner-fb/reply/reply-template/AddReplyTemplate.vue'),
      },
      {
        path: 'replies/edit-template/:id',
        name: 'owner:reply-template-edit',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "reply-template" */ '@/views/owner-fb/reply/reply-template/EditReplyTemplate.vue'),
      },
      {
        path: 'comment/templates',
        name: 'owner:comment-templates',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "comment-template" */ '@/views/owner-fb/reply/comment/CommentTemplatesTable.vue'),
      },
      {
        path: 'comment/templates/:id?',
        name: 'owner:comment-template',
        meta: { pageFeatures: [PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "comment-template" */ '@/views/owner-fb/reply/comment/ProcessCommentTemplate.vue'),
      },
      {
        path: 'published-posts',
        name: 'owner:published-posts',
        meta: { pageFeatures: [PAGE_FEATURES.POSTER, PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "posts" */ '@/views/owner-fb/poster/PublishedPostsPage.vue'),
      },
      {
        path: 'scheduled-posts',
        name: 'owner:scheduled-posts',
        meta: { pageFeatures: [PAGE_FEATURES.POSTER, PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "posts" */ '@/views/owner-fb/poster/ScheduledPostsPage.vue'),
      },
      {
        path: 'poster/:id?',
        name: 'owner:poster',
        meta: { pageFeatures: [PAGE_FEATURES.POSTER, PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "posts" */ '@/views/owner-fb/poster/AddPostPage.vue'),
      },
      {
        path: 'fb-scheduled-posts',
        name: 'owner:fb-scheduled-posts',
        meta: { pageFeatures: [PAGE_FEATURES.POSTER, PAGE_FEATURES.REPLY] },
        component: () => import(/* webpackChunkName: "posts" */ '@/views/owner-fb/poster/ScheduledFbPostsPage.vue'),
      },
      {
        path: 'subscribers',
        name: 'owner:subscribers',
        meta: { pageFeatures: [PAGE_FEATURES.REFERRAL] },
        component: () => import(/* webpackChunkName: "subscribers" */ '@/views/owner-fb/page/ReferralPagesTable.vue'),
      },
      {
        path: 'pages/accounts',
        name: 'owner:pages-accounts',
        component: () => import(/* webpackChunkName: "page-accounts" */ '@/views/owner-fb/page/PageAccountsTable.vue'),
      },
    ],
  },
]
